import pluralize from "pluralize";
import { createElementWithInitalClasses, setMultipleAttributes } from "../utils/htmlUtils";

const MAX_FILTER_SIZE = 15;
const TOO_MANY_PRODUCTS = 1000;

export class FilterHandler {

    /**
     * 
     * @param {HTMLElement} filterContainer 
     * @param {HTMLElemnt} filterModal 
     * @param {Function} onChangeEvnt 
     */
    constructor(filterContainer, filterModal, onChangeEvnt) {
        this.onChangeCallback = onChangeEvnt;

        this.filterContainer = filterContainer;
        this.filterModal = filterModal;

        // Set up events for modal
        filterModal.addEventListener("show.bs.modal", this._onModalShow.bind(this));
        filterModal.addEventListener("hidden.bs.modal", this._onModalHide.bind(this));
    }

    _onModalShow(e) {
        const showThisFilter = e.relatedTarget?.dataset.filter || null;

        //Before we show the modal we want to generate it's content
        if (!this.filters) {
            e.preventDefault();
            console.warn("cannot yet open modal, filters don't exist");
            return;
        }

        const urlParams = new URLSearchParams(window.location.search);

        for (const filterType in this.filters) {
            const filterValues = this.filters[filterType];
            const filterTypeIndex = Object.keys(this.filters).indexOf(filterType);

            let indexToPass = filterTypeIndex; 
            if(typeof(showThisFilter) == "string"){
                indexToPass = showThisFilter == filterType ? 0 : 1;
            }

            this._doGenModal(filterType, indexToPass, filterValues);

            if (urlParams.has(filterType)) {
                const allValues = urlParams.getAll(filterType);
                allValues.forEach(val => this.filterModal.querySelector(`[data-filters="${filterType}"] input[type="checkbox"][value="${val}"]`).checked = true);
            }
        }
        // Event gets destroyed when we close the modal. Make sure it's re-added
        this._onChangeEvent(this.filterModal);
    }

    _onModalHide() {
        this._clearFilterModal();
    }

    _onChangeWrapper(e) {
        // Make sure _ALL_ the filter of the same type/value are checked the same
        const filterType = e.target.dataset.filter;
        const val = e.target.value;
        const checked = e.target.checked;
        document.querySelectorAll(`[data-filters="${filterType}"] input[type="checkbox"][value="${val}"]`).forEach(e => e.checked = checked);

        this.onChangeCallback(e);
    }

    _onChangeEvent(parentEle) {
        parentEle.querySelectorAll("input").forEach(e => {
            e.removeEventListener("change", this._onChangeWrapper.bind(this));
            e.addEventListener("change", this._onChangeWrapper.bind(this));
        });
    }

    getCheckbox(filterType, option, isModal = false) {
        const div = createElementWithInitalClasses("div", "col-12", "col-md-6");
        div.setAttribute("data-is-filter", true);

        const count = typeof (option.count) == "number" ? `<span class="badge bg-gray badge-pill">${option.count}</span>` : "";
        const filterId = `${option.id}_${filterType}_check` + (isModal ? "_modal" : "");

        div.innerHTML = `
        <div class="form-check">
            <input class="form-check-input" type="checkbox" data-filter="${filterType}" value="${option.id}" id="${filterId}">
            <label class="form-check-label" for="${filterId}">
                ${option.text} ${count}
            </label>
        </div>
        `;
        return div;
    }

    filtersLoading(isLoading) {
        this.filterContainer.querySelector("[data-container-type='loading']").classList.toggle("d-none", !isLoading);
        this.filterContainer.querySelector("[data-container-type='data']").classList.toggle("d-none", isLoading);
    }

    _getSearch(filterType, valueAmount) {
        const div = createElementWithInitalClasses("div", "col-12", "py-3");

        const formFloating = createElementWithInitalClasses("div", "form-floating");

        const formId = `modalFilters_${filterType}_search`;
        const searchText = `Search ${pluralize(filterType, valueAmount)}`;

        const label = createElementWithInitalClasses("label");
        const input = createElementWithInitalClasses("input", "form-control");

        setMultipleAttributes(input, {
            "for": formId,
            "data-for-filter": filterType
        });

        label.innerText = searchText;
        setMultipleAttributes(input, {
            "type": "text",
            "placeholder": searchText,
            "id": formId,
        });

        formFloating.append(input, label);
        div.append(formFloating);
        div.setAttribute("data-is-search", true);

        input.addEventListener("keyup", this._searchInputKeyup.bind(this));

        return div;
    }

    _searchInputKeyup(e) {
        const type = e.target.dataset.forFilter;
        const value = e.target.value;

        this.filterModal.querySelectorAll(`[data-filters="${type}"] div.row div[data-is-filter="true"]`).forEach(rowDiv => {
            if (!value) {
                rowDiv.classList.toggle("d-none", false);
            } else {
                const label = rowDiv.querySelector("label").innerText;
                const containsSearch = label.toLowerCase().includes(value.toLowerCase());
                rowDiv.classList.toggle("d-none", !containsSearch);
            }
        });

    }

    _doGenModal(filterType, filterTypeIndex, filterValues) {
        // Generate the modal tabs & tab-content
        const filterModalDiv = this._generateModalTab(filterType, filterTypeIndex);

        const searchDiv = this._getSearch(filterType, filterValues.lenght);
        filterModalDiv.append(searchDiv);

        filterModalDiv.append(...filterValues.map(x => this.getCheckbox(filterType, x, true)));
    }

    /**
     * 
     * @param {Object<string, string[]>} d 
     */
    _doFilterPopuldation(d) {
        const urlParams = new URLSearchParams(window.location.search);

        const allFilterContainers = document.querySelectorAll("[data-container-type='filterBadges']");
        allFilterContainers.forEach(e => e.innerHTML = "");

        for (const filterType in d) {
            const filterValues = d[filterType];
            //const filterTypeIndex = Object.keys(d).indexOf(filterType);

            const filterDiv = this.filterContainer.querySelector(`[data-filters="${filterType}"]`);
            if (filterDiv) filterDiv.innerHTML = "";

            // const filterModalDiv = this.filterModal.querySelector(`[data-filters="${filterType}"]`);
            // if (filterModalDiv) filterModalDiv.innerHTML = "";

            // Generate the filters inside the accordion
            let set = filterValues.filter(x => x.count ? x.count < TOO_MANY_PRODUCTS : true);
            if (filterValues.length > MAX_FILTER_SIZE) {
                set = set.slice(0, MAX_FILTER_SIZE);
            }
            set.forEach(option => {
                filterDiv?.append(this.getCheckbox(filterType, option));
            });

            document.querySelectorAll(`[data-filter="${filterType}"][data-bs-target="#${this.filterModal?.id}"]`)?.forEach(e => e.classList.toggle("d-none", filterValues.length == set.length));

            if (urlParams.has(filterType)) {
                const allValues = urlParams.getAll(filterType);

                const badge = createElementWithInitalClasses("span", "badge", "bg-gray", "badge-pill", "ms-2");
                badge.innerText = `${filterType}: ${allValues.length}`;

                // Show the user what filters we have selected
                allFilterContainers.forEach(e => {
                    e.appendChild(badge);
                });

                allValues.forEach(val => {
                    document.querySelectorAll(`[data-filters="${filterType}"] input[type="checkbox"][value="${val}"]`).forEach(e => e.checked = true);
                });
            }
        }
    }

    _clearFilterModal() {
        this.filterModal.querySelectorAll("[data-container-type]").forEach(e => e.innerHTML = "");
    }

    _generateModalTab(filterType, index) {
        const tabId = `modalFilters_${filterType}_tab`;
        const tabContentId = `modalFilters_${filterType}`;

        const button = createElementWithInitalClasses("button", "nav-link", "text-capitalize");
        button.id = tabId;

        setMultipleAttributes(button, {
            "data-filter": filterType,
            "data-bs-toggle": "tab",
            "data-bs-target": `#${tabContentId}`
        });
        button.innerText = filterType;

        const div = createElementWithInitalClasses("div", "tab-pane", "fade");

        const wrapper = createElementWithInitalClasses("div", "row");
        wrapper.classList.add("row");
        div.append(wrapper);

        setMultipleAttributes(div, {
            "aria-labelledby": tabId,
            "data-filters": filterType,
            "tabindex": 0,
            "role": "tabpanel"
        });
        div.id = tabContentId;

        if (index == 0) {
            button.classList.add("active");
            button.setAttribute("aria-current", "tab");
            div.classList.add("active", "show");
        }

        this.filterModal.querySelector("[data-container-type='filterButtons']").appendChild(button);
        this.filterModal.querySelector("[data-container-type='filterTabs']").appendChild(div);

        return wrapper;
    }

    updateFilters(newData) {
        this.filters = newData;

        this._doFilterPopuldation(newData);
        this._onChangeEvent(this.filterContainer);
    }


}
